module.exports = __webpack_public_path__ + "static/media/Reiki-border.7c490754.webp";